export default __webpack_public_path__ + "static/media/SonetGallery5.ec285e82.jpg";